module.exports = __webpack_public_path__ + "img/mm-logo-white.7439a543.png";